const Carousel = (el) => {
  let currentIndex = 0;

  const ease = "power3.out";
  const duration = 0.6;

  const maxXDistance = 500;
  const minXDistance = 250;
  const maxZDistance = 400;
  const minZDistance = 200;
  const zInc = 100;
  const opacityInc = 0.05;
  const maxOpacity = 0.75;
  const minOpacity = 0.5;
  const SELECTORS = {
    SLIDE: ".carousel__item",
    OVERLAY: ".overlay",
    CONTAINER: ".carousel__items",
    PAGINATION: ".pagination",
    PAGINATION_ITEM: ".pagination-item",
    PAGINATION_CURRENT_ITEM: ".pagination-item.current",
    CONTROLS: ".controls",
    NEXT: ".controls .next",
    PREV: ".controls .prev",
  };

  const slides = [...el.querySelectorAll(SELECTORS.SLIDE)];
  const container = el.querySelector(SELECTORS.CONTAINER);
  const dots = el.querySelector(SELECTORS.PAGINATION);
  const controls = el.querySelector(SELECTORS.CONTROLS);

  const goTo = (index, immediate = false) => {
    const method = immediate ? gsap.set : gsap.to;
    const dots = [...el.querySelectorAll(SELECTORS.PAGINATION_ITEM)];
    if (currentIndex !== undefined)
      dots[currentIndex].classList.remove("current");
    dots[index].classList.add("current");

    let offset;

    // move slides
    // all behind

    for (let i = index - 1; i > -1; i--) {
      offset = Math.min(index - i - 1, 2);

      method(slides[i].querySelector(".overlay"), {
        opacity: [0.4, 0.8, 0.8][offset],
        ease,
        duration,
      });

      method(slides[i], {
        x: -[minXDistance, maxXDistance, maxXDistance][offset],
        z: -[minZDistance, maxZDistance, maxZDistance + 80][offset],
        ease,
        duration,
      });
    }

    method(slides[index], {
      x: 0,
      z: 0,
      ease,
      duration,
    });

    method(slides[index].querySelector(".overlay"), {
      opacity: 0,
      ease,
      duration,
    });

    for (let i = index + 1; i <= slides.length - 1; i++) {
      offset = Math.min(i - index - 1, 2);
      method(slides[i].querySelector(".overlay"), {
        opacity: [0.4, 0.8, 0.8][offset],
        ease,
        duration,
      });

      method(slides[i], {
        x: [minXDistance, maxXDistance, maxXDistance][offset],
        z: -[minZDistance, maxZDistance, maxZDistance + 80][offset],
        ease,
        duration,
      });
    }

    // disable controls
    const next = el.querySelector(SELECTORS.NEXT);
    const prev = el.querySelector(SELECTORS.PREV);
    if (prev) {
      if (index === 0) {
        prev.classList.add("disabled");
      } else {
        prev.classList.remove("disabled");
      }
    }
    if (next) {
      if (index === slides.length - 1) {
        next.classList.add("disabled");
      } else {
        next.classList.remove("disabled");
      }
    }

    currentIndex = index;
  };

  const handlePaginationClick = (e) => {
    const index = [...e.currentTarget.parentElement.children].indexOf(
      e.currentTarget,
    );
    goTo(index);
  };

  const handleNext = () => {
    if (currentIndex + 1 < slides.length) goTo(currentIndex + 1);
  };

  const handlePrev = () => {
    if (currentIndex - 1 >= 0) goTo(currentIndex - 1);
  };

  const createPagination = () => {
    const item = document.createElement("div");
    item.classList.add("pagination-item");

    const dot = document.createElement("div");
    dot.classList.add("pagination-item-circle");
    item.append(dot);

    slides.forEach((slide, index) => {
      const clonedDot = item.cloneNode(true);
      clonedDot.addEventListener("click", handlePaginationClick);
      dots.appendChild(clonedDot);
    });
  };

  if (el.querySelector(SELECTORS.NEXT)) {
    el.querySelector(SELECTORS.NEXT).addEventListener("click", handleNext);
  }

  if (el.querySelector(SELECTORS.PREV)) {
    el.querySelector(SELECTORS.PREV).addEventListener("click", handlePrev);
  }

  createPagination();
  goTo(0, true);
};

export default Carousel;
